<template>
  <div class="pbd-wrap">
    <PBDLateralMenu :selected-pbd="selectedPBD" type="embed" @change-pbd="changePBD" />
    <div id="pbd-cont" class="pbd-content">
      <StatisticsContent v-if="selectedPBD === 'stat_content'" />
      <StatisticsUse v-else-if="selectedPBD === 'stat_use'" />
      <ProfilesUse v-else-if="selectedPBD === 'profiles_use'" />
    </div>
  </div>
</template>
  
<script>
import PBDLateralMenu from './PBDLateralMenu.vue'
import StatisticsContent from './StatisticsContent.vue'
import ProfilesUse from './ProfilesUse.vue'
import StatisticsUse from './StatisticsUse.vue'
export default {
  components: { PBDLateralMenu, StatisticsContent, ProfilesUse, StatisticsUse },
  data() {
    return {}
  },
  computed: {
    selectedPBD() {
      if (this.$route.query?.type) {
        return this.$route.query.type
      }
      return 'stat_content'
    },
  },
  created() {
    if (!this.$route.query.type) {
      this.$router.push({
        name: 'EmbedWebStats',
        query: {
          type: this.selectedPBD,
        },
      })
    }
  },
  methods: {
    changePBD(val) {
      //router change op
      this.$router.push({
        name: 'EmbedWebStats',
        query: {
          type: val,
        },
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.pbd-wrap
  .pbd-content
    margin-left: 150px
    padding: vw(10px) vw(20px) vw(20px)

    .mobile &
      padding: vw(10px) vw(20px) vw(20px)
      width: 100%
</style>
